"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = exports.HttpRequest = exports.HttpResponse = exports.ResponseStatus = void 0;
var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus[ResponseStatus["Success"] = 0] = "Success";
    ResponseStatus[ResponseStatus["Unauthorized"] = 1] = "Unauthorized";
    ResponseStatus[ResponseStatus["ClientFailure"] = 2] = "ClientFailure";
    ResponseStatus[ResponseStatus["ServerFailure"] = 3] = "ServerFailure";
    ResponseStatus[ResponseStatus["ConnectionFailure"] = 4] = "ConnectionFailure";
})(ResponseStatus || (exports.ResponseStatus = ResponseStatus = {}));
var HttpResponse = /** @class */ (function () {
    function HttpResponse(status, statusCode, responseJson, responseText, response) {
        this.status = status;
        this.statusCode = statusCode;
        this.responseJson = responseJson;
        this.responseText = responseText;
        this.response = response;
    }
    HttpResponse.responseFromRequest = function (request) {
        var responseText = null;
        var responseJson = null;
        if (request.responseType == '' || request.responseType == 'text') {
            responseText = request.responseText;
            try {
                responseJson = JSON.parse(request.responseText);
            }
            catch (e) {
                if (e instanceof TypeError) {
                    // Error in parsing the response
                    responseJson = null;
                }
            }
        }
        var status = (function () {
            if (request.status == 0) {
                // Internet or URL failure
                return ResponseStatus.ConnectionFailure;
            }
            else if (request.status >= 200 && request.status < 300) {
                // Success!
                return ResponseStatus.Success;
            }
            else if (request.status >= 400 && request.status < 500) {
                // Client Failure!!!!!
                if (request.status == 401) {
                    return ResponseStatus.Unauthorized;
                }
                else {
                    return ResponseStatus.ClientFailure;
                }
            }
            else if (request.status >= 500 && request.status < 600) {
                // Server Failure!!!!!
                return ResponseStatus.ServerFailure;
            }
            else {
                console.error('¯\_(ツ)_/¯');
                return ResponseStatus.ServerFailure;
            }
        })();
        return new HttpResponse(status, request.status, responseJson, responseText, request.response);
    };
    return HttpResponse;
}());
exports.HttpResponse = HttpResponse;
var HttpRequest = /** @class */ (function () {
    // Remains a class to allow for in-place changing
    function HttpRequest(method, url, urlParams, body, headers, responseType) {
        if (responseType === void 0) { responseType = null; }
        this.method = method;
        this.url = url;
        this.urlParams = urlParams;
        this.body = body;
        this.headers = headers;
        this.responseType = responseType;
    }
    return HttpRequest;
}());
exports.HttpRequest = HttpRequest;
var HttpClient = /** @class */ (function () {
    function HttpClient(config) {
        this.config = config;
    }
    HttpClient.objectsToParams = function (data) {
        return Object.keys(data).map(function (key) {
            return "".concat(key, "=").concat(encodeURIComponent(String(data[key])));
        }).join('&');
    };
    HttpClient.prototype.buildUrl = function (httpRequest) {
        var _this = this;
        var requestUrl = (function () {
            if (_this.config.baseUrl == null) {
                return httpRequest.url;
            }
            else {
                var urlBase = _this.config.baseUrl.replace(/\/($)/g, '$1');
                var providedUrl = httpRequest.url.replace(/(^)\//g, '$1');
                return "".concat(urlBase, "/").concat(providedUrl);
            }
        })();
        if (httpRequest.urlParams != null && Object.keys(httpRequest.urlParams).length > 0) {
            requestUrl += "?".concat(HttpClient.objectsToParams(httpRequest.urlParams));
        }
        return requestUrl;
    };
    HttpClient.prototype.sendRequest = function (httpRequest, callback) {
        var request = new XMLHttpRequest();
        httpRequest = this.config.transformRequest ? this.config.transformRequest(httpRequest) : httpRequest;
        request.onreadystatechange = function () {
            if (request.readyState == request.DONE) {
                callback(httpRequest, HttpResponse.responseFromRequest(request));
            }
        };
        if (httpRequest.responseType != null) {
            request.responseType = httpRequest.responseType;
        }
        request.open(httpRequest.method, this.buildUrl(httpRequest), true);
        var headers = httpRequest.headers || {};
        Object.keys(headers).forEach(function (key) {
            request.setRequestHeader(key, headers[key]);
        });
        if (httpRequest.body != null) {
            try {
                request.send(JSON.stringify(httpRequest.body));
            }
            catch (e) {
                if (e instanceof TypeError) {
                    callback(httpRequest, new HttpResponse(ResponseStatus.ClientFailure, -1, null, null, null));
                }
            }
        }
        else {
            request.send(null);
        }
    };
    HttpClient.prototype.get = function (url, urlParams, callback, headers, responseType) {
        this.sendRequest(new HttpRequest('GET', url, urlParams, null, headers || null, responseType), callback);
    };
    HttpClient.prototype.put = function (url, urlParams, body, callback, headers, responseType) {
        this.sendRequest(new HttpRequest('PUT', url, urlParams, body, headers || null, responseType), callback);
    };
    HttpClient.prototype.post = function (url, urlParams, body, callback, headers, responseType) {
        this.sendRequest(new HttpRequest('POST', url, urlParams, body, headers || null, responseType), callback);
    };
    HttpClient.prototype.del = function (url, urlParams, callback, headers, responseType) {
        this.sendRequest(new HttpRequest('DELETE', url, urlParams, null, headers || null, responseType), callback);
    };
    return HttpClient;
}());
exports.HttpClient = HttpClient;
//# sourceMappingURL=spoonClient.js.map